import TagManager from 'react-gtm-module';
import { get, set } from 'idb-keyval'; // Already in your dependencies

// Store for runtime configuration
let runtimeConfig = {
  googleAnalyticsId: ''
};

// Fetch runtime configuration from server
export const fetchConfig = async () => {
  try {
    const response = await fetch('/api/config');
    if (response.ok) {
      runtimeConfig = await response.json();
      return runtimeConfig;
    }
  } catch (error) {
    console.error('Error fetching runtime configuration:', error);
  }
  return runtimeConfig;
};

// Initialize GTM with consent state
export const initializeGTM = async (consentState = {}) => {
  // Ensure we have the latest config
  await fetchConfig();

  const gtmArgs = {
    gtmId: runtimeConfig.googleAnalyticsId || '',
    dataLayer: {
      // Set initial consent state
      'consent_mode': {
        'analytics_storage': consentState.analytics || 'denied',
        'ad_storage': 'denied', // Always deny ad storage for this implementation
        'personalization_storage': 'denied',
        'functionality_storage': 'denied',
        'security_storage': 'granted' // Security cookies are always allowed
      }
    },
    dataLayerName: 'dataLayer'
  };

  // Only initialize if we have a valid GTM ID
  if (gtmArgs.gtmId && gtmArgs.gtmId !== '') {
    TagManager.initialize(gtmArgs);
  }
};

// Update consent state when user changes preferences
export const updateConsentState = (category, consent) => {
  if (category === 'analytics') {
    // Update GTM consent state
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'consent_update',
      'consent_mode': {
        'analytics_storage': consent ? 'granted' : 'denied'
      }
    });

    // Store consent state in IndexedDB for persistence
    get('consentState').then((state = {}) => {
      const newState = { ...state, analytics: consent ? 'granted' : 'denied' };
      set('consentState', newState);
    });
  }
};

// Check for existing consent
export const checkExistingConsent = async () => {
  try {
    const consentState = await get('consentState') || {};
    return consentState;
  } catch (error) {
    console.error('Error retrieving consent state:', error);
    return {};
  }
};
